import { wallpaperAssets, wallpaperTemplate } from './wallpaper';
import { systemChatbotMessage } from './system';

export const chatbotSimpleAssets = {
  ...wallpaperAssets,
  // Add new assets here
};

export const chatbotSimpleTemplates = {
  system: systemChatbotMessage,
  wallpaper_kingkong_1080: wallpaperTemplate('kingkong', '1080'),
  wallpaper_kingkong_1170: wallpaperTemplate('kingkong', '1170'),
  wallpaper_candyland_1170: wallpaperTemplate('candyland', '1170'),
  wallpaperMigration: wallpaperTemplate('migration', '1170'),
  wallpaperMigrationCompensation: wallpaperTemplate('candyland', '1170'),
};
